import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAllPeople } from "../../api/people";
import PeopleCard from "../../components/people/PeopleCard";
import PeopleCardSkeleton from "../../components/people/PeopleCardSkeleton";
import YellowDivider from "../../components/dividers/YellowDivider";
import PageHeadingWithImage from "../../components/pageheading/PageHeadingWithImage";
import { People } from "../../compilers/people";
import "../../stylesheet/pages/PeoplePage.scss";

const PeoplePage: React.FC = () => {
  const [people, setPeopleContent] = useState<People[]>();
  const { i18n, t } = useTranslation();

  useEffect(() => {
    setPeopleContent(undefined);
    //if (ready) {
    getAllPeople("en").then((response: People[]) => {
      if (response) {
        setPeopleContent(response.sort(() => 0.5 - Math.random()));
        //console.log("People are:", response);
      }
    });
    // }
  }, [i18n.language]);

  const getPerson = () => {
    //console.log(typeof people);
    if (people) {
      return people.map((person) => {
        //console.log(person);
        return <PeopleCard key={person.id} media={person} />;
        //return "1";
      });
    } else {
      return (
        <>
          <PeopleCardSkeleton />
          <PeopleCardSkeleton />
          <PeopleCardSkeleton />
          <PeopleCardSkeleton />
          <PeopleCardSkeleton />
          <PeopleCardSkeleton />
          <PeopleCardSkeleton />
          <PeopleCardSkeleton />
        </>
      );
    }
  };

  return (
    <div className="main">
      <PageHeadingWithImage
        className="ze-people"
        title={t("ze-people.heading.title")}
        subtitle={t("ze-people.heading.subtitle")}
        body={t("ze-people.heading.body")}
      />
      <div className="container">
        <div className="mb-3 mb-lg-4">
          <h2>{t("ze-people.people-section")}</h2>
          <YellowDivider heading="h2" />
        </div>
        <div className="people-catalogue-wrapper">{getPerson()}</div>
      </div>
    </div>
  );
};

export default PeoplePage;
